 import React, { useRef } from 'react';

import { Element } from 'react-scroll';

import emailjs from '@emailjs/browser';

const Contact = () => {
  const handleSubmit = (e) => {
    e.preventDefault();
    emailjs.sendForm('service_nh0jo9x', 'template_jrraef7', form.current, 'RCeqM3ZWKBuVE8nW7')
    .then((result) => {
        console.log(result.text);
        }, (error) => {console.log(error.text)}
    );
    form.current.reset();
  }

  const form = useRef();

  return (
    <Element name="contact" className="p-6 bg-gray-100 text-navy">
    <div class="md:w-3/4 md:mx-auto">
    <div className="my-8 text-4xl font-bold">
    	Contact Brian
    </div>
    <form id="contact-form" ref={form} onSubmit={handleSubmit}>
      <div className="grid grid-cols-2 gap-4 md:grid-cols-4">
        <div className="flex flex-col">
          <label htmlFor="first-name">First name</label>
          <input type="text" id="first-name" name="first-name" className="px-3 py-2 border-2 rounded-md form-input border-navy" required />
        </div>
        <div className="flex flex-col">
          <label htmlFor="last-name">Last name</label>
          <input type="text" id="last-name" name="last-name" className="px-3 py-2 border-2 rounded-md form-input border-navy" required />
        </div>
        <div className="flex flex-col">
          <label htmlFor="email">Email</label>
          <input type="email" id="email" name="email" className="px-3 py-2 border-2 rounded-md form-input border-navy" required />
        </div>
        <div className="flex flex-col">
          <label htmlFor="phone">
            <div className="flex align-items">
              Phone
              <span className="ml-auto opacity-75">Optional</span>
            </div>
          </label>
          <input type="tel" id="phone" name="phone" className="px-3 py-2 border-2 rounded-md form-input border-navy" />
        </div>
        <div className="flex flex-col col-span-2">
          <label htmlFor="subject">Subject</label>
          <input type="text" id="subject" name="subject" className="px-3 py-2 border-2 rounded-md form-input border-navy" required />
        </div>
        <div className="flex flex-col col-span-2 md:col-span-4">
          <label htmlFor="subject">
            <div className="flex align-items">
              Message
              <span className="ml-auto opacity-75">Max. 500 characters</span>
            </div>
          </label>
          <textarea maxLength="500" rows="4" type="text" id="message" name="message" className="px-3 py-2 border-2 rounded-md form-input border-navy" required />
        </div>
      </div>
      <div className="flex justify-end py-4">
        <button type="submit" class="bg-navy text-white font-bold py-2 px-4 rounded focus:ring focus:ring-blue-300 hover:bg-blue-700">
          Submit
        </button>
      </div>
    </form>
    </div>
  </Element>
  );
};

export default Contact;